module.exports = __webpack_public_path__ + "img/No-Claims-Discount.62648163.png";